module.exports = __webpack_public_path__ + "static/media/BCH.2acd4bda.png";